import { useEffect, useCallback } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchInstruments = () => {
  const { apiGet } = useApi();
  const useApiState = createApiHook([]);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const fetchData = useCallback(async () => {
    startLoading();
    const response = await apiGet("/instruments", "Error al obtener los instrumentos");
    setResponse(response);
    return response?.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { data, error, loading, refetch: fetchData };
};

export default useFetchInstruments;
